import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import { GroupTransportFilter } from "components/Common/GroupTransportSelect";
import ConfirmModal from "components/shared-components/ConfirmModal";
import HubFilter from "components/shared-components/RemoteTable/HubFilter/HubFilter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { actionAccess } from "constants/actionAccess";
import {
  ORDER_TYPE_RECEIVE,
  ORDER_TYPE_RETURN,
  SHIPPING_TYPE,
  TIME_SLOT_TYPE,
} from "constants/order";
import {
  CheckActionAccess,
  CheckActionAccessList,
  getTransportTrackingLink,
  useQueryRouter,
} from "helpers/utils";
import {
  useCancelOrder,
  useCancelOrderReasonList,
  useChangeOrderStatusMultiple,
  useCheckRole,
  useExportOrders,
  useForwardOrderMultiple,
  useListNewSendOrderScanTotal,
  useOrderStatus,
  useRetryOrder,
  useTimeSlots,
} from "hooks";
import UpdateRefCodeModal from "pages/ ScanTheRow/UpdateRefCode/UpdateRefCodeModal";
import {
  checkErrorForHandleOrdersCoordinate,
  checkItemAcceptForUpdateExitsRefCode,
  copyInformationOrderToClipboard,
  orderStatusMode,
} from "pages/Orders/utils";
import React, { useEffect, useRef, useState } from "react";
import { DateRangePicker } from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { useTranslation } from "react-i18next";
import MetaTags from "react-meta-tags";
import { useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  Row,
  Spinner,
} from "reactstrap";
import ChangeOrderStatusForm from "../Orders/OrderDetail/ChangeOrderStatusForm/ChangeOrderStatusForm";
import OrderCoordinationForm from "../Orders/OrderDetail/OrderCoordination/OrderCoordinationForm/OrderCoordinationForm";
import RefCode from "pages/Orders/RefCode";

const initRunnerByRuleParams = {
  action_date: "",
  time_slot: 0,
  province_code: "",
  district_code: "",
  ward_code: "",
};

const ManageNewSendOrderScanTotalPage = () => {
  let queryRouter = useQueryRouter();
  const updateRefCodeModalRef = useRef(null);
  const initParams = () => {
    return {
      sizePerPage: 10,
      page: 1,
      columnFilter: {
        transport_group_code: "runner",
      },
      keywords: "",
      expand: "from_hub_name,to_hub_name,transport_name",
      run: false,
    };
  };

  const { t } = useTranslation(["myOrders"]);
  const { addToast } = useToasts();
  const navigate = useNavigate();

  const allFilterOption = {
    value: "All",
    label: t("filters.all"),
  };

  const statusOptionDisplay = ["1", "2", "6"];

  /* ================================== START INIT STATE ==================================== */

  const [orderParams, setOrderParams] = useState(initParams);
  const [columnsTable, setColumnsTable] = useState([]);
  const [actionType, setActionType] = useState(false);
  const [statusFilter, setStatusFilter] = useState(false);
  const [timeFilter, setTimeFilter] = useState(false);
  const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
  const [selectedTimeFilter, setSelectedTimeFilter] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [focusedInput, setFocusedInput] = useState(null);
  const [selectedRow, setSelectedRow] = useState({});
  const [selectedIds, setSelectedIs] = useState([]);
  const [selectedOrderCode, setSelectedOrderCode] = useState([]);
  const [hubId, setHubId] = useState(null);
  const [runnerByRuleParams, setRunnerByRuleParams] = useState(
    initRunnerByRuleParams
  );
  const [openForwardOrderPopup, setOpenForwardOrderPopup] = useState(false);
  const [orderStatusList, setOrderStatusList] = useState([]);
  const [statusListAllOptions, setStatusListAllOptions] = useState([]);
  const [timeListAllOptions, setTimeListAllOptions] = useState([]);
  const [dataCancelOrder, setDataCancelOrder] = useState({
    orderId: null,
  });
  const [cancelOrderModal, setCancelOrderModal] = useState(false);
  const [openChangeOrderStatusPopup, setOpenChangeOrderStatusPopup] =
    useState(false);
  const [isFilterConsolidated, setIsFilterConsolidated] = useState(false);
  const { isLogAdmin, isHubAdmin } = useCheckRole();

  /* =================================== END INIT STATE ===================================== */

  /* ===================================== START HOOKS ====================================== */

  const isAllowCreate = CheckActionAccess(actionAccess.GLOG_FUNCTION_ORDER_ADD);
  const isAllowExport = CheckActionAccess(
    actionAccess.GLOG_FUNCTION_ORDER_EXPORT
  );

  // TIME SLOTS

  const [timeSlotsParams, setTimeSlotsParams] = useState({
    params: {
      "filter[type][in]": [TIME_SLOT_TYPE.COORDINATE, TIME_SLOT_TYPE.RUNNER],
      "filter[hub_id]": undefined,
    },
    run: false,
    enabled: false,
    key: "time-slot-orders",
  });

  const { data: timeSlots, refetch: refetchTimeSlots } =
    useTimeSlots(timeSlotsParams);

  useEffect(() => {
    if (timeSlotsParams && timeSlotsParams?.run) {
      refetchTimeSlots();
    }
  }, [timeSlotsParams]);

  // FORWARD ORDER

  const onSuccessForwardOrder = () => {
    listOrders();
  };

  const { mutate: onForwardOrder } = useForwardOrderMultiple(
    onSuccessForwardOrder
  );

  // CHANGE ORDER STATUS

  const onSuccessChangeOrderStatus = () => {
    listOrders();
  };

  const { mutate: changeOrderStatus } = useChangeOrderStatusMultiple(
    onSuccessChangeOrderStatus
  );

  // CANCEL ORDER

  const handleCancelOrderSuccess = () => {
    listOrders();
  };

  const { mutate: cancelOrder } = useCancelOrder(handleCancelOrderSuccess);

  // REASONS

  const { refetch: onFetchOrderReason, data: reasonListData } =
    useCancelOrderReasonList(1);

  // ORDER STATUS

  const onFetchOrderStatusSuccess = response => {
    // Set default status query filter
    const queryStatus = queryRouter.get("statuses")?.split(",");
    if (queryStatus) {
      const listDefaultStatus = response.filter(n =>
        queryStatus.find(item => item === n.value)
      );
      listDefaultStatus && setSelectedStatusFilter(listDefaultStatus);
    }
    //
    setOrderStatusList(response);
    setStatusListAllOptions([allFilterOption, ...response]);
  };

  const { refetch: onFetchOrderStatus } = useOrderStatus(
    onFetchOrderStatusSuccess
  );

  // EXPORT ORDER
  const exportOrderParams = {
    params: {
      ...orderParams,
      columnFilter: {
        ...orderParams.columnFilter,
        "filter[id][in]": selectedIds,
      },
    },
  };

  const onExportSuccess = data => {
    if (data) {
      const outputFilename = `ExportFile-${Date.now()}.xlsx`;
      const url = URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", outputFilename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  };

  const { isLoading: isExportingFile, refetch: exportOrders } = useExportOrders(
    exportOrderParams,
    onExportSuccess
  );

  // ORDERS

  const {
    data: orderList,
    isFetching: isLoadingListOrder,
    refetch: listOrders,
  } = useListNewSendOrderScanTotal({
    params: orderParams,
  });

  useEffect(() => {
    setOrderParams(prev => ({
      ...prev,
      page: 1,
      sizePerPage: 10,
      columnFilter: {
        ...prev.columnFilter,
        "filter[transport_id]": queryRouter.get("transport") || undefined,
        "filter[orderstatus]": queryRouter.get("statuses")
          ? queryRouter.get("statuses").split(",")
          : statusOptionDisplay,
        "filter[type]": queryRouter.get("type"),
        dashboard_key: queryRouter.get("key"),
      },
    }));
    setTimeListAllOptions([
      {
        value: "ALL",
        label: "Tất cả",
      },
      {
        value: [0, 0],
        label: "0 ngày",
      },
      {
        value: [1, 2],
        label: "Từ 1->2 ngày",
      },
      {
        value: [2, 3],
        label: "Từ 2->3 ngày",
      },
      {
        value: [3, 4],
        label: "Từ 3->4 ngày",
      },
      {
        value: ">=5",
        label: "Hơn 5 ngày",
      },
    ]);

    onFetchOrderStatus();
  }, []);

  useEffect(() => {
    if (orderParams && orderParams.run) {
      listOrders();
    }
  }, [orderParams]);

  useEffect(() => {
    if (orderList) {
      setColumnsTable(initColumns);
      setSelectedIs([]);
    }
  }, [orderList]);

  useEffect(() => {
    setColumnsTable(initColumns);
  }, [orderStatusList]);

  /* ===================================== END HOOKS ======================================== */

  /* ================================ START FUNCTION HANDLER ================================ */

  const handleForwardOrder = data => {
    const forwardOrderParams = { ...data };
    forwardOrderParams.ids = selectedIds;
    onForwardOrder(forwardOrderParams);
  };

  const handleChangeOrderStatus = data => {
    const orderParams = { ...data };
    orderParams.ids = selectedIds;
    changeOrderStatus(orderParams);
  };

  const formatStatus = cell => {
    const status = statusListAllOptions.find(
      item => parseInt(item.value) === cell
    );
    return <div>{status?.label}</div>;
  };

  const formatType = cell => {
    const type =
      cell === ORDER_TYPE_RECEIVE.value
        ? ORDER_TYPE_RECEIVE
        : ORDER_TYPE_RETURN;
    return <div>{type?.label}</div>;
  };

  const clickViewOrderHandler = row => {
    navigate(`/manage-orders/${row.id}`);
  };

  const rightClickViewOrderHandler = (row, indexCol, e) => {
    if (e && (e.button === 1 || e.button === 2)) {
      window.open(`/manage-orders/${row.id}`, "_blank", "noopener,noreferrer");
    }
  };

  const toggleCancelOrderModal = () => {
    setCancelOrderModal(!cancelOrderModal);
  };

  const clickCancelOrderHandler = row => {
    setSelectedRow(row);
    setDataCancelOrder({ orderId: row.id });
    toggleCancelOrderModal();
    onFetchOrderReason();
  };

  const cancelSingleOrderHandler = value => {
    if (value.reasonId) {
      cancelOrder({
        orderId: dataCancelOrder.orderId,
        reason_note: value.note,
        reason_id: value.reasonId,
        order_code: selectedRow?.["order_code"],
      });
      toggleCancelOrderModal();
    }
  };

  const onSetDaySize = () => {
    if (window.matchMedia("(max-width: 560px)").matches) {
      return 22;
    }
    if (window.matchMedia("(max-width: 800px)").matches) {
      return 24;
    }
    return undefined;
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder }
  ) => {
    const columnFilter = orderParams.columnFilter || {};

    setOrderParams(prev => ({
      ...prev,
      sort: sortField ? sortOrder + sortField : orderParams.sort,
      columnFilter: {
        ...prev.columnFilter,
        ...columnFilter,
      },
      page: page || 1,
      sizePerPage: sizePerPage || 10,
    }));
  };

  const handleRowsSelect = (ids, row) => {
    setSelectedIs(ids);
    setSelectedOrderCode(row.map(item => item.order_code));
    setHubId(null);
  };

  const handleStatusFilter = status => {
    const columnFilter = { ...orderParams.columnFilter };

    if (status.value !== "All") {
      setSelectedStatusFilter(status?.label);
      columnFilter["filter[orderstatus]"] = status.value;
    } else {
      setSelectedStatusFilter("");
      columnFilter["filter[orderstatus]"] = statusOptionDisplay;
    }

    setOrderParams(prev => ({
      ...prev,
      columnFilter,
    }));
  };

  const handleTimeFilter = time => {
    const columnFilter = { ...orderParams.columnFilter };

    if (time.value === ">=5") {
      setSelectedTimeFilter(time.label);
      delete columnFilter["delay_time_to"];
      columnFilter["delay_time_from"] = 5;
    } else if (time.value === "ALL") {
      setSelectedTimeFilter("");
      delete columnFilter["delay_time_from"];
      delete columnFilter["delay_time_to"];
    } else {
      setSelectedTimeFilter(time.label);
      columnFilter["delay_time_from"] = time.value[0];
      columnFilter["delay_time_to"] = time.value[1];
    }

    setOrderParams(prev => ({
      ...prev,
      columnFilter,
    }));
  };

  const handleOrderTypeFilter = type => {
    const columnFilter = { ...orderParams.columnFilter };

    if (type.value !== "All") {
      columnFilter["filter[type]"] = type.value;
    } else {
      delete columnFilter["filter[type]"];
    }

    setOrderParams(prev => ({
      ...prev,
      columnFilter,
    }));
  };

  const columnFilterDateHandler = isRunner => {
    const columnFilter = { ...orderParams.columnFilter };
    // let fieldReplace = isRunner ? "action_date" : "maker_date";
    // let fieldOld = isRunner ? "maker_date" : "action_date";
    // for (const key in columnFilter) {
    //   if (key.includes(fieldOld)) {
    //     let keyNew = key.replace(fieldOld, fieldReplace);
    //     columnFilter[keyNew] = columnFilter[key];
    //     delete columnFilter[key];
    //   }
    // }
    return columnFilter;
  };

  const handleConsolidatedFilter = () => {
    const columnFilter = columnFilterDateHandler(!isFilterConsolidated);

    setIsFilterConsolidated(!isFilterConsolidated);
    delete columnFilter["filter[transport_id]"];
    delete columnFilter["transport_group_code"];

    if (!isFilterConsolidated) {
      columnFilter["filter[is_sub_order]"] = 1;
      columnFilter["filter[parent_id]"] = "NULL";
      columnFilter["filter[orderstatus]"] = orderStatusMode.MAKE;

      setSelectedStatusFilter("Tạo đơn");
    } else {
      delete columnFilter["filter[is_sub_order]"];
      delete columnFilter["filter[transport_id]"];
      delete columnFilter["filter[parent_id]"];
      delete columnFilter["filter[orderstatus]"];
      setSelectedStatusFilter("");
    }

    setOrderParams(prev => ({
      ...prev,
      columnFilter,
    }));
  };

  const onSearchAllHandle = value => {
    setOrderParams(prev => ({
      ...prev,
      keywords: value,
    }));
  };

  const handleDateRangeFilter = ({ startDate, endDate }) => {
    const columnFilter = { ...orderParams.columnFilter };

    setStartDate(startDate);
    setEndDate(endDate);

    delete columnFilter["filter[action_date][gte]"];
    delete columnFilter["filter[action_date][lte]"];
    delete columnFilter["filter[maker_date][gte]"];
    delete columnFilter["filter[maker_date][lte]"];
    delete columnFilter["filter[action_date][eq]"];
    delete columnFilter["filter[maker_date][eq]"];
    let keyFilter = "maker_date";
    if (startDate && endDate) {
      columnFilter[`filter[${keyFilter}][gte]`] = startDate
        ? startDate.format("YYYY-MM-DD")
        : null;
      columnFilter[`filter[${keyFilter}][lte]`] = endDate
        ? endDate.format("YYYY-MM-DD")
        : null;
    } else if (startDate) {
      columnFilter[`filter[${keyFilter}][eq]`] = startDate
        ? startDate.format("YYYY-MM-DD")
        : null;
    } else if (endDate) {
      columnFilter[`filter[${keyFilter}][eq]`] = endDate
        ? endDate.format("YYYY-MM-DD")
        : null;
    }
    setOrderParams(prev => ({
      ...prev,
      columnFilter,
    }));
  };

  const handleExportFile = () => {
    if (selectedIds.length === 0) {
      addToast(t("message.not_selected_information"), {
        appearance: "warning",
        autoDismiss: true,
      });
      return;
    }
    exportOrders();
  };

  const handleCoordinate = () => {
    if (selectedIds && selectedIds.length > 0) {
      let { messError, hub_id } = checkErrorForHandleOrdersCoordinate({
        selectedRows: selectedOrderCode,
      });

      if (messError) {
        addToast(messError, {
          appearance: "warning",
          autoDismiss: true,
        });
      } else {
        setHubId(hub_id);
        setTimeSlotsParams(prev => {
          return {
            ...prev,
            params: {
              ...prev.params,
              "filter[hub_id]": hub_id,
            },
            run: true,
          };
        });
        setOpenForwardOrderPopup(!openForwardOrderPopup);
      }
    } else {
      addToast(t("message.not_selected_information"), {
        appearance: "warning",
        autoDismiss: true,
      });
    }
  };

  const handleChangeStatus = () => {
    if (selectedIds && selectedIds.length > 0) {
      setOpenChangeOrderStatusPopup(!openChangeOrderStatusPopup);
    } else {
      addToast(t("message.not_selected_information"), {
        appearance: "warning",
        autoDismiss: true,
      });
    }
  };

  const onFetchRetryOrderSuccess = response => {
    listOrders();
  };
  const onFetchRetryOrderFail = response => {};

  const { mutate: mutateRetryOrder } = useRetryOrder(
    onFetchRetryOrderSuccess,
    onFetchRetryOrderFail
  );

  const handleSendBackDVVC = () => {
    if (selectedOrderCode && selectedOrderCode.length > 0) {
      mutateRetryOrder(selectedOrderCode);
    } else {
      addToast(t("message.not_selected_information"), {
        appearance: "warning",
        autoDismiss: true,
      });
    }
  };

  /* ================================ END FUNCTION HANDLER ================================= */

  const initColumns = [
    {
      dataField: "delay_time",
      text: t("table.time"),
      sort: true,
      formatter: cell => {
        return cell;
      },
    },
    {
      dataField: "order_code",
      text: t("table.id"),
      sort: true,
    },
    {
      dataField: "ref_code",
      text: t("table.package_code"),
      sort: true,
      formatter: (cell, row) => {
        const isAllowUpdateRefCode = true;
        const isAllowUpdateExistRefCode =
          isLogAdmin && checkItemAcceptForUpdateExitsRefCode(row);
        return (
          <RefCode
            t={t}
            ref_code={cell}
            data={row}
            isAllowUpdateRefCode={isAllowUpdateRefCode}
            onUpdateRefCode={() =>
              updateRefCodeModalRef?.current?.openModal({
                orderId: row?.id,
                orderRefCode: row.ref_code,
              })
            }
            isAllowUpdateExistRefCode={isAllowUpdateExistRefCode}
            onUpdateExistRefCode={() =>
              updateRefCodeModalRef?.current?.openModal({
                orderId: row?.id,
                orderRefCode: row.ref_code,
                isUpdateExist: true,
              })
            }
          />
        );
      },
    },
    {
      dataField: "from_hub_name",
      text: "Nơi gửi",
      formatter: cell => {
        return <div className="text-info fw-bold">{cell}</div>;
      },
    },
    {
      dataField: "to_hub_name",
      text: "Nơi nhận",
      formatter: cell => {
        return <div className="text-success fw-bold">{cell}</div>;
      },
    },
    {
      dataField: "status",
      text: t("table.status"),
      sort: true,
      formatter: cell => {
        return formatStatus(cell);
      },
    },
    {
      dataField: "sender_name",
      text: t("table.customer"),
      sort: true,
      formatter: (cell, row) => {
        return row.type === 1 ? row.reciever_name : row.sender_name;
      },
    },
    {
      dataField: "sender_contact_phone",
      text: t("table.SDT"),
      sort: true,
      formatter: (cell, row) => {
        return row.type === 1
          ? row.reciever_contact_phone
          : row.sender_contact_phone;
      },
    },
    {
      dataField: "address",
      text: t("table.address"),
      sort: true,
      formatter: (cell, row) => {
        return row.type === 2
          ? row.sender_full_address
          : row.reciever_full_address;
      },
    },
    {
      dataField: "transport_name",
      text: t("table.transport_id"),
      sort: true,
    },
    {
      dataField: "sale_name",
      text: t("table.sale"),
      sort: true,
    },
    {
      dataField: "time_slot_name",
      text: t("table.timeslot_id"),
      sort: true,
      formatter: (cell, row) => {
        return cell;
      },
    },
  ];

  const listRowAction = [
    {
      actionAccess: actionAccess.GLOG_FUNCTION_ORDER_VIEW,
      icon: <i className="fas fa-eye fa-lg text-primary ms-2" />,
      text: t("actions.view"),
      onClick: clickViewOrderHandler,
      onRightClick: rightClickViewOrderHandler,
    },
    {
      icon: <i className="fas fa-copy fa-lg text-info" />,
      text: "Copy thông tin",
      onClick: row =>
        copyInformationOrderToClipboard({
          order_code: row.order_code,
          ref_code: row.ref_code,
          status: statusListAllOptions.find(
            item => parseInt(item.value) === row.status
          )?.label,
          customer: row.type === 1 ? row.reciever_name : row.sender_name,
          phone:
            row.type === 1
              ? row.reciever_contact_phone
              : row.sender_contact_phone,
          address:
            row.type === 2
              ? row.sender_full_address
              : row.reciever_full_address,
        }),
    },
    {
      actionAccess: actionAccess.GLOG_FUNCTION_ORDER_CANCEL,
      icon: <i className="fas fa-times fa-lg ms-2 text-danger" />,
      text: t("actions.cancel"),
      onClick: clickCancelOrderHandler,
      conditionVisible: {
        status: [6],
      },
    },
  ];
  const rowActionList = CheckActionAccessList(listRowAction, "actionAccess");

  const selectRow = {
    mode: "checkbox",
    // clickToSelect: true,
    bgColor: "#00BFFF",
    onSelect: handleRowsSelect,
  };
  // TRANSPORT

  const onChangeGroupTransport = selected => {
    // if (selected && selected.value !== "runner") {
    //   setTransportChoosen(selected);
    // }
    if (selected) {
      setOrderParams(prev => ({
        ...prev,
        columnFilter: {
          ...prev.columnFilter,
          "filter[transport_id]": undefined,
          transport_group_code: selected.value,
          "filter[shipping_type][in]": undefined,
        },
      }));
    } else {
      setOrderParams(prev => ({
        ...prev,
        columnFilter: {
          ...prev.columnFilter,
          "filter[transport_id]": undefined,
          transport_group_code: undefined,
          "filter[shipping_type][in]": [
            SHIPPING_TYPE.DVVC,
            SHIPPING_TYPE.NHAXE,
          ],
        },
      }));
    }
  };

  const handleChangeRunnerOrTransport = type => {
    if (type === "runner") {
      onChangeGroupTransport({
        label: "Runner",
        value: "runner",
      });
    }

    if (type === "transport") {
      onChangeGroupTransport(undefined);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Modal
          isOpen={openForwardOrderPopup}
          centered
          toggle={() => {
            setOpenForwardOrderPopup(!openForwardOrderPopup);
          }}
          scrollable
          size="xl"
        >
          {openForwardOrderPopup && (
            <OrderCoordinationForm
              hubId={hubId}
              timeSlots={timeSlots?.items}
              handleCancel={() => {
                setOpenForwardOrderPopup(false);
              }}
              onTimeSlotChange={timeslot_id => {
                const params = { ...runnerByRuleParams };
                params.time_slot = timeslot_id;
                setRunnerByRuleParams(params);
              }}
              onActionDateChange={action_date => {
                const params = { ...runnerByRuleParams };
                params.action_date = action_date;
                setRunnerByRuleParams(params);
              }}
              onForwardOrder={handleForwardOrder}
            />
          )}
        </Modal>

        <Modal
          isOpen={openChangeOrderStatusPopup}
          centered
          toggle={() =>
            setOpenChangeOrderStatusPopup(!openChangeOrderStatusPopup)
          }
        >
          <ChangeOrderStatusForm
            orderStatusList={orderStatusList}
            handleCancel={() => {
              setOpenChangeOrderStatusPopup(false);
            }}
            onSubmit={handleChangeOrderStatus}
          />
        </Modal>
        <MetaTags>
          <title>Manage New Send Order Scan Total</title>
        </MetaTags>
        <div className="container-fluid">
          <BreadcrumbWithLink
            title={
              t("title.manageNewSendOrderScanTotal") +
              ` (${orderList?.totalCount || 0})`
            }
          />
          <Row>
            {/* Modal START*/}
            <Col className="col-12">
              <UpdateRefCodeModal
                ref={updateRefCodeModalRef}
                handleOnSuccessInsertOrderRefCode={() => {
                  listOrders();
                }}
              />
              <ConfirmModal
                isOpen={cancelOrderModal}
                titleHeader={
                  t("actions.deleteModal.title") +
                  `${selectedRow?.["order_code"] || ""}` +
                  "?"
                }
                titleBody={t("actions.deleteModal.content")}
                onConfirm={cancelSingleOrderHandler}
                textBtnConfirm={t("actions.deleteModal.confirmBtn")}
                textBtnCancel={t("actions.deleteModal.cancelBtn")}
                toggle={toggleCancelOrderModal}
                isReasonDeleteCheckbox={true}
                reasonList={reasonListData?.items}
                isHaveNote={true}
              />
            </Col>

            {/* Modal E N D*/}
            <Col className="col-12">
              <Card>
                <CardBody>
                  <RemoteDataTable
                    isShowRowIndex={false}
                    keyField="id"
                    data={orderList?.items || []}
                    columns={columnsTable}
                    selectRow={selectRow}
                    page={orderList?.params?.page}
                    sizePerPage={orderList?.params?.sizePerPage}
                    totalSize={orderList?.totalCount}
                    onTableChange={handleTableChange}
                    onSearchAllHandle={onSearchAllHandle}
                    listRowAction={rowActionList}
                    onRowsSelect={handleRowsSelect}
                    loading={isLoadingListOrder}
                    searchSticky={true}
                    sizePerPageListAppend={[
                      {
                        text: "100",
                        value: 100,
                      },
                    ]}
                  >
                    <div className="d-flex flex-column flex-md-row flex-grow-0 flex-lg-grow-1 flex-md-wrap justify-content-md-between">
                      <div
                        className="d-flex flex-column flex-sm-wrap flex-sm-row mb-md-0"
                        style={{ gap: "0.5rem" }}
                      >
                        <div>
                          <DateRangePicker
                            numberOfMonths={1}
                            startDate={startDate}
                            startDateId="s_id"
                            endDate={endDate}
                            endDateId="e_id"
                            startDatePlaceholderText={t("title.startDate")}
                            endDatePlaceholderText={t("title.endDate")}
                            isOutsideRange={() => false}
                            onDatesChange={handleDateRangeFilter}
                            focusedInput={focusedInput}
                            onFocusChange={e => setFocusedInput(e)}
                            displayFormat="DD/MM/YYYY"
                            daySize={onSetDaySize()}
                            orientation={
                              window.matchMedia("(max-width: 700px)").matches
                                ? "vertical"
                                : "horizontal"
                            }
                          />
                        </div>
                        <HubFilter
                          label={"Hub"}
                          isForOrder
                          mainFilterParams={orderParams}
                          setMainFilterParams={setOrderParams}
                          handleChangeHub={() => {
                            // Reset Filter order theo ĐVVC
                            setOrderParams(prev => ({
                              ...prev,
                              columnFilter: {
                                ...prev.columnFilter,
                                "filter[transport_id]": undefined,
                              },
                            }));
                          }}
                          isNotFilterChildHub={true}
                          isHaveAllOption={isLogAdmin}
                          isFilterAllDefault={true}
                        />
                        <div className="order-search-status">
                          <Dropdown
                            isOpen={statusFilter}
                            toggle={() => setStatusFilter(!statusFilter)}
                          >
                            <DropdownToggle
                              className="btn primary-btn w-100"
                              caret
                            >
                              {t("filters.status.label")}
                              {selectedStatusFilter && (
                                <span>:&nbsp;{selectedStatusFilter}</span>
                              )}
                              <i className="mdi mdi-chevron-down" />
                            </DropdownToggle>
                            <DropdownMenu className="w-100">
                              {statusListAllOptions?.length > 0 &&
                                statusListAllOptions.map((status, index) => {
                                  if (
                                    ["All", "1", "2", "6"].includes(
                                      status.value
                                    )
                                  ) {
                                    return (
                                      <DropdownItem
                                        key={`status-${index}`}
                                        onClick={() =>
                                          handleStatusFilter(status)
                                        }
                                      >
                                        {status.label}
                                      </DropdownItem>
                                    );
                                  }
                                })}
                            </DropdownMenu>
                          </Dropdown>
                        </div>
                        {/* START FILTER TIME */}
                        <div>
                          <Dropdown
                            isOpen={timeFilter}
                            toggle={() => setTimeFilter(!timeFilter)}
                          >
                            <DropdownToggle
                              className="btn primary-btn w-100"
                              caret
                            >
                              {t("filters.time.label")}
                              {selectedTimeFilter && (
                                <span>:&nbsp;{selectedTimeFilter}</span>
                              )}
                              <i className="mdi mdi-chevron-down" />
                            </DropdownToggle>
                            <DropdownMenu className="w-100">
                              {timeListAllOptions?.length > 0 &&
                                timeListAllOptions.map((time, index) => (
                                  <DropdownItem
                                    key={`time-${index}`}
                                    onClick={() => handleTimeFilter(time)}
                                  >
                                    {time.label}
                                  </DropdownItem>
                                ))}
                            </DropdownMenu>
                          </Dropdown>
                        </div>
                        {/* END FILTER TIME */}
                        <div>
                          <GroupTransportFilter
                            label={"ĐVVC"}
                            onChange={onChangeGroupTransport}
                            primary={
                              !orderParams.columnFilter.transport_group_code ||
                              orderParams.columnFilter.transport_group_code !==
                                "runner"
                            }
                            watchValue={
                              orderParams.columnFilter.transport_group_code ===
                                "runner" ||
                              !orderParams.columnFilter.transport_group_code
                                ? "all"
                                : undefined
                            }
                            runnerVisible={false}
                          />
                        </div>
                        <div>
                          <Button
                            className="mb-2 w-100"
                            color={
                              orderParams.columnFilter.transport_group_code ===
                              "runner"
                                ? "primary"
                                : "secondary"
                            }
                            type="button"
                            onClick={() => {
                              handleChangeRunnerOrTransport(
                                orderParams.columnFilter
                                  .transport_group_code === "runner"
                                  ? "transport"
                                  : "runner"
                              );
                            }}
                          >
                            {"Runner"}
                          </Button>
                        </div>
                        {!isHubAdmin && (
                          <div>
                            <Button
                              className="mb-2 w-100"
                              color={
                                isFilterConsolidated ? "primary" : "secondary"
                              }
                              type="button"
                              onClick={() => {
                                handleConsolidatedFilter();
                              }}
                            >
                              {"Đơn gom"}
                            </Button>
                          </div>
                        )}
                      </div>

                      <div className="d-flex justify-content-md-end">
                        {isAllowCreate && (
                          <Button
                            className="mb-2 w-100"
                            type="button"
                            color="primary"
                            onClick={() => {
                              navigate(
                                `/manage-orders/create${
                                  selectedOrderCode?.length > 0
                                    ? `/?sub_order_codes=${selectedOrderCode.join(
                                        ","
                                      )}`
                                    : ""
                                }`
                              );
                            }}
                          >
                            {"Tạo đơn mới"}
                          </Button>
                        )}
                        {isAllowExport && (
                          <div className="ms-2">
                            <Dropdown
                              isOpen={actionType}
                              toggle={() => setActionType(!actionType)}
                            >
                              <DropdownToggle
                                className="btn primary-btn w-100"
                                caret
                              >
                                {"Tác vụ"}{" "}
                                <i className="mdi mdi-chevron-down" />{" "}
                                {!!isExportingFile && (
                                  <Spinner
                                    // style={{ marginLeft: "5px" }}
                                    color="white"
                                    size="sm"
                                  />
                                )}
                              </DropdownToggle>
                              <DropdownMenu>
                                <DropdownItem onClick={handleExportFile}>
                                  {t("actions.exportFile")}{" "}
                                </DropdownItem>
                                {!isHubAdmin && (
                                  <>
                                    <DropdownItem onClick={handleCoordinate}>
                                      {t("actions.coordinate")}{" "}
                                    </DropdownItem>
                                    <DropdownItem onClick={handleChangeStatus}>
                                      {t("actions.change_status")}{" "}
                                    </DropdownItem>
                                    <DropdownItem onClick={handleSendBackDVVC}>
                                      {t("actions.send_back_dvvc")}{" "}
                                    </DropdownItem>
                                  </>
                                )}
                              </DropdownMenu>
                            </Dropdown>
                          </div>
                        )}
                      </div>
                    </div>
                  </RemoteDataTable>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ManageNewSendOrderScanTotalPage;
